import gql from "graphql-tag";

export default gql`
    mutation($idAudio: Int!, $idProject: Int!){
        removeRelation(idAudio: $idAudio, idProject: $idProject)
  }
`;
